import * as React from 'react';
import {clsx} from 'clsx';

import {SvgIconReact} from 'common/components/svg-icon';
import {pluralize} from 'common/util/string';
import {react2panel} from 'common/util/react2panel';

export const PopoverBodyReact = (props: {
  isAggregate: boolean;
  propertyAggregation: string;
  retainedCount: string;
  dataGroupName: string;
  dataGroupNamePlural: string;
  retainedPercent: string;
  dropOffCount: string;
  dropOffPercent: string;
  /** Hacky way to pass down css module styles from a React parent using css
   * modules. This is a stop-gap till all the parents are converted to React.*/
  cssModule?: any;
}) => {
  const propertyAggregation = props.propertyAggregation ? ` ${props.propertyAggregation}` : ``;

  return (
    <>
      <div className={clsx(`popover-content-wrapper`, props.cssModule?.popoverContentWrapper)}>
        <div className={clsx(`popover-slot`, props.cssModule?.popoverSlot)}>
          <SvgIconReact
            icon={`community`}
            className={clsx(
              `popover-icon`,
              `converted-icon`,
              props.cssModule?.popoverIcon,
              props.cssModule?.convertedIcon,
            )}
          />
          <div className={clsx(`popover-content`, `count`, props.cssModule?.popoverContent, props.cssModule?.count)}>
            <span className={clsx(`bold`, props.cssModule?.bold)}>{props.retainedCount}</span>
            <span>
              {` `}
              retained{` `}
              {props.isAggregate
                ? `(average)${propertyAggregation}`
                : props.propertyAggregation
                  ? props.propertyAggregation
                  : pluralize(
                      props.dataGroupName,
                      parseInt(props.retainedCount.replace(/,/g, ``)),
                      props.dataGroupNamePlural,
                    )}
            </span>
          </div>
          {props.propertyAggregation ? null : (
            <div className={clsx(`percentage`, props.cssModule?.percentage)}>
              <span className={clsx(`bold`, props.cssModule?.bold)}>{props.retainedPercent}</span>
            </div>
          )}
        </div>
        {props.propertyAggregation ? null : (
          <div className={clsx(`popover-slot`, props.cssModule?.popoverSlot)}>
            <SvgIconReact
              icon={`circle-decrease`}
              className={clsx(
                `popover-icon`,
                `drop-off-icon`,
                props.cssModule?.popoverIcon,
                props.cssModule?.dropOffIcon,
              )}
            />
            <div
              className={clsx(
                `popover-content`,
                `drop_off_count`,
                props.cssModule?.popoverContent,
                props.cssModule?.drop_off_count,
              )}
            >
              <span className={clsx(`bold`, props.cssModule?.bold)}>{props.dropOffCount}</span>
              <span>
                {` `}
                dropped{` `}
                {props.isAggregate
                  ? `(average)`
                  : pluralize(
                      props.dataGroupName,
                      parseInt(props.dropOffCount.replace(/,/g, ``)),
                      props.dataGroupNamePlural,
                    )}
              </span>
            </div>
            <div className={clsx(`drop_off_percentage`, props.cssModule?.drop_off_percentage)}>
              <span className={clsx(`bold`, props.cssModule?.bold)}>{props.dropOffPercent}</span>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export const popoverBody = react2panel(`mp-popover-body`, PopoverBodyReact);
